import type { SheetIndicator } from "components/financials/modern/types";
import { IIndicatorKind } from "types/graphqlTypes";

export default function isRangeSelectionSupported(indicator: SheetIndicator | null) {
  if (!indicator) {
    return false;
  }
  return [
    IIndicatorKind.Financial,
    IIndicatorKind.Currency,
    IIndicatorKind.Percent,
    IIndicatorKind.Metric,
    IIndicatorKind.Percent,
    IIndicatorKind.Ratio,
    IIndicatorKind.Text,
  ].includes(indicator.kind as any);
}
